<template>
  <div class="animated fadeIn">
    <i
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>n</v-btn> انبار جدید

          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-expansion-panels v-model="allOpen" multiple focusable>
      <!-- <i class="fa fa-list-ol"></i> -->
      <v-expansion-panel class="p-0 border mb-1">
        <v-expansion-panel-header disable-icon-rotate>
          <h4 :style="'color: ' + type.color">{{ type.name }}</h4>
          <template v-if="type.icon" v-slot:actions>
            <v-icon :color="type.color">
              {{ type.icon }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="my-1 p-0">
          <v-btn
            class="darkGreen-mainBtn white--text my-4 float-start"
            style="width: 135px; height: 35px;"
            @click="$refs.activeTable.$el.click()"
            depressed
            :disabled="!allWarehouses.length"
          >
            <v-icon class="me-1"> mdi-file-excel-outline </v-icon>
            خروجی اکسل
          </v-btn>
          <vue-excel-xlsx
            ref="activeTable"
            :data="allWarehouses"
            :columns="warehousesFieldsExcel"
            :sheet-name="`محصولات`"
            :file-name="`محصولات`"
          ></vue-excel-xlsx>
          <v-btn
            :disabled="gettingReceipt || !allWarehouses.length"
            class="darkRed-mainBtn white--text my-4 float-end"
            @click="printReceipt()"
            style="width: 135px; height: 35px;"
            depressed
            ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
          >

          <b-table
            responsive
            show-empty
            :id="'warehouse' + type.index"
            :items="allWarehouses"
            :fields="warehousesFields"
            empty-text="بخشی در این انبار تعریف نشده است"
            striped
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <b-button
                class="btn-primary mr-2"
                @click="goToWarehouseProfile(data.item)"
                >کاردکس انبار</b-button
              >
              <b-button
                class="btn-warning"
                @click="openEditWarehouseDialog(data.item, type)"
                >ویرایش</b-button
              >
              <b-button
                v-if="role == 'Manager'"
                @click="deleteWarehouse(data.item)"
                class="btn-danger mr-2"
                >حذف</b-button
              >
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>

          <v-btn
            style="float: left"
            @click="openNewWarehouseDialog(type)"
            class="btn-success"
            v-shortkey.once="['n']"
            @shortkey="openNewWarehouseDialog(type)"
          >
            + ثبت انبار جدید +
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <hr />
    </v-expansion-panels>

    <v-dialog v-model="newWarehouseDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>
            ثبت انبار جدید در <em>{{ selectedType.name }}</em>
          </h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام انبار"
              v-model="newWarehouseName"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="توضیحات انبار"
              v-model="newWarehouseDescription"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newWarehouseDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="addWarehouse()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editWarehouseDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>
            ویرایش <em>{{ selectedWarehouse.name }}</em> از
            <em>{{ selectedType.name }}</em>
          </h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <!-- <p><span style="color:red"> * </span>وارد کردن نام جدید الزامی است.</p> -->
            <v-text-field
              outlined
              dense
              label="نام جدید بخش"
              v-model="editName"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="توضیحات جدید بخش"
              v-model="editDescrtipion"
            ></v-text-field>
            <v-select
              label="وضعیت"
              :items="statusOpt"
              v-model="status"
              outlined
              dense
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="closeEditWarehouseDialog()"
          >
            لغو
          </v-btn>
          <v-btn
            color="primary"
            :disabled="
              editName == selectedWarehouse.name &&
              status == selectedWarehouse.status &&
              editDescrtipion == selectedWarehouse.description
            "
            @click="editWarehouse()"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view></router-view>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">محصولات</h3>
      <b-table :data="allWarehouses" :columns="warehousesFieldsPrint">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios"; // NOTE (IMPORT) to read the data from back_end of project
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site

export default {
  data() {
    return {
      guide: false,
      printInvoice: {},
      gettingReceipt: false,
      isBusy: false,
      type: Var.allTypes[0],
      newWarehouseDialog: false,
      selectedType: {},
      newWarehouseName: "",
      newWarehouseDescription: "",
      warehousesFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام انبار" },
        { key: "status", label: "وضعیت انبار" },
        { key: "operation", label: "عملیات" },
      ],
      warehousesFieldsExcel: [
        { field: "index", label: "ردیف" },
        { field: "name", label: "نام انبار" },
        { field: "status", label: "وضعیت انبار" },
      ],
      warehousesFieldsPrint: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام انبار" },
        { key: "status", label: "وضعیت انبار" },
      ],
      allWarehouses: [],
      editWarehouseDialog: false,
      selectedWarehouse: {},
      editName: "",
      editDescrtipion: "",
      status: "",
      statusOpt: ["فعال", "غیر فعال"],
      allOpen: [0],
    };
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    getWarehouses() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouses/getByType",
        {
          warehouseTypeId: this.type.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allWarehouses = res.data;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
          this.isBusy = false;
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    openEditWarehouseDialog(warehouse, type) {
      this.selectedWarehouse = warehouse;
      this.selectedType = type;
      this.editName = warehouse.name;
      this.editDescrtipion = warehouse.description;
      this.status = warehouse.status;
      this.editWarehouseDialog = true;
    },
    closeEditWarehouseDialog() {
      this.editWarehouseDialog = false;
    },
    editWarehouse() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/edit",
        {
          warehouseId: this.selectedWarehouse.id,
          warehouseTypeId: this.selectedType.id,
          name: this.editName,
          description: this.editDescrtipion,
          status: this.status,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getWarehouses();
            this.editWarehouseDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    deleteWarehouse(warehouse) {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/delete",
        {
          warehouseId: warehouse.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getWarehouses();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openNewWarehouseDialog(type) {
      this.selectedType = type;
      this.newWarehouseDialog = true;
    },
    goToWarehouseProfile(item) {
      this.$router.push("/warehouse/profile/" + item.id);
    },
    addWarehouse() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/new",
        {
          warehouseTypeId: this.selectedType.id,
          name: this.newWarehouseName,
          description: this.newWarehouseDescription,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newWarehouseName = "";
            this.newWarehouseDescription = "";
            this.newWarehouseDialog = false;
            this.getWarehouses();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
            this.newWarehouseDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
          this.newWarehouseDialog = false;
        });
    },
  },
  mounted() {
    this.getWarehouses();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
